import { reducer as formReducer } from 'redux-form';

export default formReducer;
